import decimal from 'decimal.js';
import {
  words,
} from './globalState';
import {
  getValidKeyPairs,
  signWithKey,
  getAddressFromKey,
  checkIfAddressIsMatchedWithTwoAddresses,
} from './keysAndSigning';
import {
  setAddressesInCookie,
} from './monacottoMisc';
import {
  getAssetInfo,
  buildMonapartyTransactions,
  broadcastMonaTransactions,
  deleteCart,
  addTokensToTheCartMonaparty,
} from './blockchain';
import {
  syncHttpRequest2,
  devLog,
} from './utils';

// 「出品:署名」ボタン押下 -- HANDLE CLICK SIGN EXHIBIT
async function handleClickSignExhibit(state, dispatch, cookies, setCookie, addressType, keyPairs) {
  let addressActual;

  // トークン存在チェック

  // トークン保有量チェック

  let request = {};
  let messages = {};
  let bodyObj = {};

  // state固定
  const stateFixed = {
    exhibitNo: state.exhibit.exhibitNo,
    addressMain: state.exhibit.addressMain,
    // addressMainCoinType: state.exhibit.addressMainCoinType,
    exhibitType: 'singleToken',
    addressCardFrom: state.exhibit.addressCardFrom,
    addressPayProceedsTo: state.exhibit.addressPayProceedsTo,
    monacottoAddressMonaparty: state.exhibit.monacottoAddressMonaparty,
    tokenName: state.exhibit.tokenName,
    amountToSell: state.exhibit.amountToSell,
    priceMona: state.exhibit.priceMona.value,
    signatureVersion: state.config.clientParameters.signatureVersion.exhibit,
    minimumAmountToSell: state.config.clientParameters.amountToSellRange.min,
    maximumAmountToSell: state.config.clientParameters.amountToSellRange.max,
    minimumPriceMona: state.config.clientParameters.priceMonaRange.min,
    maximumPriceMona: state.config.clientParameters.priceMonaRange.max,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 必須項目チェック
  if (stateFixed.addressMain === undefined || stateFixed.addressMain === null || stateFixed.addressMain === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.mainAddressMustBeFilled[state.language] });
    return { status: 'rejected' };
  }

  if (stateFixed.addressCardFrom === undefined || stateFixed.addressCardFrom === null || stateFixed.addressCardFrom === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.addressYouSendCardsFromMustBeFilled[state.language] });
    return { status: 'rejected' };
  }

  if (stateFixed.addressPayProceedsTo === undefined || stateFixed.addressPayProceedsTo === null || stateFixed.addressPayProceedsTo === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.addressYouReceiveProceedsInMustBeFilled[state.language] });
    return { status: 'rejected' };
  }

  if (stateFixed.tokenName === undefined || stateFixed.tokenName === null || stateFixed.tokenName === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.tokenNameMustBeFilled[state.language] });
    return { status: 'rejected' };
  }

  if (stateFixed.amountToSell === undefined || stateFixed.amountToSell === null || stateFixed.amountToSell === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.amountToSellMustBeFilled[state.language] });
    return { status: 'rejected' };
  }

  if (stateFixed.priceMona === undefined || stateFixed.priceMona === null || stateFixed.priceMona === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.unitPriceMustBeFilled[state.language] });
    return { status: 'rejected' };
  }

  // 数量チェック
  if (stateFixed.amountToSell < stateFixed.minimumAmountToSell) {
    dispatch({ type: 'setNotification', key: 'notification',
      value: `${words.amountToSellMustBeEqualOrMoreThanX1[state.language]} ${stateFixed.minimumAmountToSell} ${words.amountToSellMustBeEqualOrMoreThanX2[state.language]}`
    });
    return { status: 'rejected' };
  }

  if (stateFixed.amountToSell > stateFixed.maximumAmountToSell) {
    dispatch({ type: 'setNotification', key: 'notification',
      value: `${words.amountToSellMustBeEqualOrLessThanX1[state.language]} ${stateFixed.maximumAmountToSell} ${words.amountToSellMustBeEqualOrLessThanX2[state.language]}`
    });
    return { status: 'rejected' };
  }

  if (stateFixed.priceMona < stateFixed.minimumPriceMona) {
    dispatch({ type: 'setNotification', key: 'notification',
      value: `${words.unitPriceMustBeEqualOrMoreThanXMona1[state.language]} ${stateFixed.minimumPriceMona} ${words.unitPriceMustBeEqualOrMoreThanXMona2[state.language]}`
    });
    return { status: 'rejected' };
  }

  if (stateFixed.priceMona > stateFixed.maximumPriceMona) {
    dispatch({ type: 'setNotification', key: 'notification',
      value: `${words.unitPriceMustBeEqualOrLessThanXMona1[state.language]} ${stateFixed.maximumPriceMona} ${words.unitPriceMustBeEqualOrLessThanXMona2[state.language]}`
    });
    return { status: 'rejected' };
  }

  // monacottoAddressMonaparty決定
  if (stateFixed.exhibitNo === null || stateFixed.exhibitNo === '') {
    stateFixed.monacottoAddressMonaparty = state.config.monacottoAddress.monacottoAddressMonaparty[0];
    dispatch({ type: 'setStateMultiLayers', keys: ['exhibit', 'monacottoAddressMonaparty'], value: stateFixed.monacottoAddressMonaparty });
  }

  const clientTime = Date.now();
  const message = `I want to sell ${stateFixed.amountToSell} ${stateFixed.tokenName}(s) for ${stateFixed.priceMona} MONA per unit. I want receive proceeds in ${stateFixed.addressPayProceedsTo}. I want to exhibit them as ${stateFixed.addressMain}. I will send tokens from ${stateFixed.addressCardFrom} to ${stateFixed.monacottoAddressMonaparty}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;

  let signature;
  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  if (
    addressType === 'addressMain' && keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined ||
    addressType === 'addressCardFrom' && keyPairsInPool[stateFixed.addressCardFrom]?.keyPair !== undefined
  ) {
    let keyPair;

    if (addressType === 'addressMain') {
      addressActual = stateFixed.addressMain;
      keyPair = keyPairsInPool[stateFixed.addressMain].keyPair;
    }
    else { // addressCardFrom
      addressActual = stateFixed.addressCardFrom;
      keyPair = keyPairsInPool[stateFixed.addressCardFrom].keyPair;
    }

    const result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    const keyPair = keyPairs[0];
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return 'rejected';
    }

    if (!checkIfAddressIsMatchedWithTwoAddresses(state, dispatch, addressActual, stateFixed.addressMain, stateFixed.addressCardFrom, addressType, stateFixed.addressCheck)) {
      return { status: 'rejected' };
    }

    // // キーカードのアドレスが合ってるかチェック

    // if (stateFixed.addressCheck === 'strict') {
    //   if (addressActual !== (addressType === 'addressMain' ? stateFixed.addressMain : stateFixed.addressCardFrom)) {
    //     dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
    //     return 'rejected';
    //   }
    // }
    // else if (stateFixed.addressCheck === 'addressSecond') {
    //   if (addressActual !== stateFixed.addressMain && addressActual !== stateFixed.addressCardFrom) {
    //     dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
    //     return 'rejected';
    //   }
    // }
    // else { // off
    // }

    result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else if (stateFixed.walletType === 'mpurse') {
    // キープールに鍵が無い。
    // Mpurseのアドレスが合ってるかチェック
    const result = await window.mpurse.getAddress()
    .then( (result) => {
      addressActual = result;

      if (stateFixed.addressCheck === 'strict') {
        if (addressActual !== (addressType === 'addressMain' ? stateFixed.addressMain : stateFixed.addressCardFrom)) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
          return 'rejected';
        }
        else {
          return 'fulfilled';
        }
      }
      else if (stateFixed.addressCheck === 'addressSecond') {
        if (addressActual !== stateFixed.addressMain && addressActual !== stateFixed.addressCardFrom) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
          return 'rejected';
        }
        else {
          return 'fulfilled';
        }
      }
      else { // off
        return 'fulfilled';
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名
    try {
      signature= await window.mpurse.signMessage(message).then( result => result );
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (
    stateFixed.walletType === 'keypool' &&
    state.active.addressMain !== undefined && state.active.addressMain !== null && state.active.addressMain !== '' &&
    keyPairsInPool[state.active.addressMain]?.keyPair !== undefined
  ) {
    const keyPair = keyPairsInPool[state.active.addressMain].keyPair;
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return 'rejected';
    }

    if (!checkIfAddressIsMatchedWithTwoAddresses(state, dispatch, addressActual, stateFixed.addressMain, stateFixed.addressCardFrom, addressType, stateFixed.addressCheck)) {
      return { status: 'rejected' };
    }

    result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else if (stateFixed.walletType === 'nfc') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcRequired',
    };
  }
  else if (stateFixed.walletType === 'nfcNative') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcNativeRequired',
    };
  }
  else { // qr
    dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    return {
      status: 'rejected',
      message: 'bcRequired',
    };
  }

  // GO！

  if (stateFixed.exhibitNo === undefined || stateFixed.exhibitNo === null || stateFixed.exhibitNo === '') {
    bodyObj = {
      "body": {
        "method": 'insert',
        "addressType": addressType,
        "addressMain": stateFixed.addressMain,
        "addressMainActual": addressActual,
        // "addressMainCoinType": stateFixed.addressMainCoinType,
        "exhibitType": stateFixed.exhibitType,
        "addressCardFrom": stateFixed.addressCardFrom,
        "addressPayProceedsTo": stateFixed.addressPayProceedsTo,
        "monacottoAddressMonaparty": stateFixed.monacottoAddressMonaparty,
        "tokenName": stateFixed.tokenName,
        "amountToSell": stateFixed.amountToSell,
        "priceMona": stateFixed.priceMona,
      }
    };

    bodyObj.body.clientTimeOfAddressMain = clientTime;
    bodyObj.body.signatureByAddressMain = signature;
    bodyObj.body.signatureVersionOfAddressMain = stateFixed.signatureVersion;

    if (stateFixed.addressMain === stateFixed.addressCardFrom) {
      bodyObj.body.clientTimeOfAddressCardFrom = clientTime;
      bodyObj.body.signatureByAddressCardFrom = signature;
      bodyObj.body.signatureVersionOfAddressCardFrom = stateFixed.signatureVersion;
    }

    request.body = JSON.stringify(bodyObj);
  }
  else {
    bodyObj = {
      "body": {
        "method": 'update',
        "addressMain": stateFixed.addressMain,
        "addressCardFromActual": addressActual,
        // "addressMainCoinType": stateFixed.addressMainCoinType,
        "exhibitNo": stateFixed.exhibitNo,
        "addressType": addressType,
      }
    };

    bodyObj.body.clientTimeOfAddressCardFrom = clientTime;
    bodyObj.body.signatureByAddressCardFrom = signature;
    bodyObj.body.signatureVersionOfAddressCardFrom = stateFixed.signatureVersion;

    request.body = JSON.stringify(bodyObj);
  }

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/exhibit';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "order expired.": words.orderExpired[state.language],
    "out of service": words.outOfService[state.language],
    "not permitted by owner.": words.notPermittedByOwner[state.language],
    "user does not exist.": words.pleaseRegisterAsAUserOnTheSetupPage[state.language],
    "you are not delegated from main address.": words.norIsTheSignatureDelegatedFromMainAddress[state.language],
    "you are not delegated from the address you send cards from.": words.norIsTheSignatureDelegatedFromAddressYouSendCardsFrom[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    const exhibit = response.body.exhibit;
    const sessionId = response.body.sessionId;
    const expirationOfSession = response.body.expirationOfSession;

    // exhibit情報更新
    dispatch({ type: 'setState', key: 'exhibit', value: exhibit });

    // session情報更新
    if (addressType === 'addressMain') {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressMain], value: {'sessionId': sessionId.addressMain, 'expirationOfSession': expirationOfSession.addressMain} });

      if (addressActual !== stateFixed.addressMain) {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', addressActual], value: {'sessionId': sessionId.addressMainActual, 'expirationOfSession': expirationOfSession.addressMainActual} });
      }

      if (sessionId.addressCardFrom !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressCardFrom], value: {'sessionId': sessionId.addressCardFrom, 'expirationOfSession': expirationOfSession.addressCardFrom} });
      }
    }
    else { // addressCardFrom
      dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressCardFrom], value: {'sessionId': sessionId.addressCardFrom, 'expirationOfSession': expirationOfSession.addressCardFrom} });

      if (addressActual !== stateFixed.addressCardFrom) {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', addressActual], value: {'sessionId': sessionId.addressCardFromActual, 'expirationOfSession': expirationOfSession.addressCardFromActual} });
      }
    }

    // オーダーNo.通知欄表示(全署名完了していたら)
    if ( exhibit.signatureByAddressMain !== undefined && exhibit.signatureByAddressMain !== null && exhibit.signatureByAddressMain !== '' &&
         exhibit.signatureByAddressCardFrom !== undefined && exhibit.signatureByAddressCardFrom !== null && exhibit.signatureByAddressCardFrom !== '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.acceptedAsExhibitNoX1[state.language] + exhibit.exhibitNo + words.acceptedAsExhibitNoX2[state.language] });
    }

    // cookie情報更新(アドレス情報)
    const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    const cookiesNew = [
          {
            action: 'exhibit',
            addressType: 'addressMain',
            description: `${userName} ${stateFixed.tokenName} ${stateFixed.amountToSell}`,
            // addressMainExhibitor: stateFixed.addressMain,
            // tokenName: stateFixed.tokenName,
            // amount: stateFixed.amountToSell,
            time: clientTime,
            address: stateFixed.addressMain
          },
    ];

    if (cookiesNew.every( cookie => cookie.address !== stateFixed.addressCardFrom )) {
      cookiesNew.push(
          {
            action: 'exhibit',
            addressType: 'addressCardFrom',
            description: `${userName} ${stateFixed.tokenName} ${stateFixed.amountToSell}`,
            time: clientTime,
            address: stateFixed.addressCardFrom
          },
      );
    }

    if (cookiesNew.every( cookie => cookie.address !== stateFixed.addressPayProceedsTo )) {
      cookiesNew.push(
          {
            action: 'exhibit',
            addressType: 'addressPayProceedsTo',
            description: `${userName} ${stateFixed.tokenName} ${stateFixed.amountToSell}`,
            time: clientTime,
            address: stateFixed.addressPayProceedsTo
          }
      );
    }

    setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
  }
  else {
  }

  return response;
}

// 「出品:カード送信」ボタン押下 HANDLE CLICK SEND TOKEN
async function handleClickSendToken(state, dispatch, keyPairs) {
  let request = {};
  let response = {};
  let messages = {};
  let txid;

  // state固定
  const stateFixed = {
    addressCardFrom: state.exhibit.addressCardFrom,
    monacottoAddressMonaparty: state.exhibit.monacottoAddressMonaparty,
    tokenName: state.exhibit.tokenName,
    amountToSell: state.exhibit.amountToSell,
    addressMain: state.exhibit.addressMain,
    exhibitNo: state.exhibit.exhibitNo,
    signatureByAddressMain: state.exhibit.signatureByAddressMain,
    walletType: state.walletType,
  };

  const buildAndBroadcast = async (keyPairsInArg) => {
    let actionItemsMultiSources;
    let divisible;
    let quantity;

    if (state.exhibit.divisible !== undefined && state.exhibit.divisible !== null) {
      divisible = state.exhibit.divisible;
    }
    else {
      // アセット情報取得

      try {
        await getAssetInfo({
          dispatch,
          assets: [stateFixed.tokenName],
          assetInfos: state.assetInfo,
          clientParameters: state.config.clientParameters,
        })
        .then( result => {
          const assetInfoTmp = result.bodyNew.find( info => info.asset === stateFixed.tokenName || info.asset_longname === stateFixed.tokenName );
          divisible = assetInfoTmp.divisible;
        })
        .catch( error => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSend[state.language] });
          throw new Error('failed to send');
        });
      }
      catch (error) {
        return { status: 'rejected' };
      }
    }

    if (divisible === true) {
      // 実は、exhibitでdivisibleはNGにしている...
      quantity = new decimal(stateFixed.amountToSell).times(100000000).toNumber();
    }
    else {
      quantity = stateFixed.amountToSell;
    }

    // まず最初にカートを空にする！

    actionItemsMultiSources = deleteCart(state, dispatch, 'cartMonaparty');

    actionItemsMultiSources = addTokensToTheCartMonaparty(
      state, dispatch, stateFixed.addressCardFrom, stateFixed.monacottoAddressMonaparty, stateFixed.tokenName, quantity, actionItemsMultiSources
    );

    for (const addressFrom of Object.keys(actionItemsMultiSources)) {
      for (const actionItem of actionItemsMultiSources[addressFrom]) {
        actionItem.status = 'unprocessed';
      }
    }

    dispatch({ type: 'setState', key: 'accessing', value: true });

    await buildMonapartyTransactions(state, dispatch, keyPairsInArg, actionItemsMultiSources);

    dispatch({ type: 'setState', key: 'accessing', value: false });

    if (actionItemsMultiSources[stateFixed.addressCardFrom][0].status === 'succeeded') {
    }
    else { // failed
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSend[state.language] });
      return { status: 'rejected' };
    }

    dispatch({ type: 'setState', key: 'accessing', value: true });

    await broadcastMonaTransactions(state, dispatch, actionItemsMultiSources);

    dispatch({ type: 'setState', key: 'accessing', value: false });

    if (actionItemsMultiSources[stateFixed.addressCardFrom][0].status === 'succeeded') {
      const txid = actionItemsMultiSources[stateFixed.addressCardFrom][0].txid;

      dispatch({ type: 'setState', key: 'exhibit',
        value: {
          exhibitNo: '',
          addressMain: state.exhibit.addressMain,
          // addressMainCoinType: 'mona',
          addressCardFrom: state.exhibit.addressCardFrom,
          addressPayProceedsTo: state.exhibit.addressPayProceedsTo,
          tokenName: '',
          amountToSell: '',
          priceMona: { face: '', value: '' },
          signatureByAddressMain: '',
          signatureByAddressCardFrom: '',
          disabled: false,
          status: 'waitingForSignature',
        }
      });

      dispatch({ type: 'setNotification', key: 'notification', value: words.sentSuccessfully[state.language] + ' ' + txid });
    }
    else { // failed
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSend[state.language] });
      return { status: 'rejected' };
    }

    txid = actionItemsMultiSources[stateFixed.addressCardFrom][0].txid;

    // 一応、カートを空にする

    deleteCart(state, dispatch, 'cartMonaparty');
  };


  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  if (keyPairsInPool[stateFixed.addressCardFrom]?.keyPair !== undefined) {
    await buildAndBroadcast(keyPairsInPool);
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    const keyPair = keyPairs[0];
    let addressActual;
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return 'rejected';
    }

    // キーカードのアドレスが合ってるかチェック

    if (addressActual !== stateFixed.addressCardFrom) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
      return 'rejected';
    }

    await buildAndBroadcast({ [addressActual]: { keyPair: keyPair } });
  }
  else if (stateFixed.walletType === 'mpurse') {
    // Mpurseが接続されているかチェック
    if (window.mpurse === undefined) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.activateMpurse[state.language] });
      return { status: 'rejected' };
    }

    // Mpurseのアドレスが合ってるかチェック
    const result = await window.mpurse.getAddress()
    .then( result => {
      if (result !== stateFixed.addressCardFrom) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
        return 'rejected';
      }
      else {
        return 'fulfilled';
      }
    })
    .catch( error => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
      return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    if (false) {
      // GO!
      const result = await window.mpurse.sendAsset(stateFixed.monacottoAddressMonaparty, stateFixed.tokenName, stateFixed.amountToSell)
      .then( async (result) => {
        devLog(result);

        dispatch({ type: 'setState', key: 'exhibit',
          value: {
            exhibitNo: '',
            addressMain: state.exhibit.addressMain,
            // addressMainCoinType: 'mona',
            addressCardFrom: state.exhibit.addressCardFrom,
            addressPayProceedsTo: state.exhibit.addressPayProceedsTo,
            tokenName: '',
            amountToSell: '',
            priceMona: { face: '', value: '' },
            signatureByAddressMain: '',
            signatureByAddressCardFrom: '',
            disabled: false,
            status: 'waitingForSignature',
          }
        });

        dispatch({ type: 'setNotification', key: 'notification', value: words.sentSuccessfully[state.language] + ' ' + result });
      })
      .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSend[state.language] });
        return 'rejected';
      });

      if (result === 'rejected') {
        return { status: 'rejected' };
      }
    }
    else {
      await buildAndBroadcast(null);
    }
  }
  else if (stateFixed.walletType === 'nfc') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcRequired',
    };
  }
  else if (stateFixed.walletType === 'nfcNative') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcNativeRequired',
    };
  }
  else { // bc
    dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    return {
      status: 'rejected',
      message: 'bcRequired',
    };
  }

  // トークン送信成功通知
  request.body = JSON.stringify({
    "body": {
      addressMain: stateFixed.addressMain,
      exhibitNo: stateFixed.exhibitNo,
      signatureByAddressMain: stateFixed.signatureByAddressMain,
      sendTokenTx_hash: txid,
    }
  });
  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/notify_sending_token';
  request.method = 'POST';
  messages = {
  };

  response = await syncHttpRequest2(request, undefined, undefined, undefined, messages, dispatch);

  return {
    status: 'fulfilled',
    body: response,
  };
}

// 「出品:デフォルト」ボタン押下
async function handleClickDefaultExhibit(state, dispatch) {
  if (state.exhibit.addressMain !== undefined && state.exhibit.addressMain !== '') {
    if (state.user[state.exhibit.addressMain] !== undefined) {
      dispatch({ type: 'setStateMultiLayers', keys: ['exhibit', 'addressCardFrom'], value: state.user[state.exhibit.addressMain].basicInformation.addressCardFromDefault });
      dispatch({ type: 'setStateMultiLayers', keys: ['exhibit', 'addressPayProceedsTo'], value: state.user[state.exhibit.addressMain].basicInformation.addressPayProceedsToDefault });
    }
    else {
    }
  }
  else if (state.login.addressMain !== undefined && state.login.addressMain !== '') {
    if (state.user[state.login.addressMain] !== undefined) {
      dispatch({ type: 'setStateMultiLayers', keys: ['exhibit', 'addressMain'], value: state.login.addressMain });
      dispatch({ type: 'setStateMultiLayers', keys: ['exhibit', 'addressCardFrom'], value: state.user[state.login.addressMain].basicInformation.addressCardFromDefault });
      dispatch({ type: 'setStateMultiLayers', keys: ['exhibit', 'addressPayProceedsTo'], value: state.user[state.login.addressMain].basicInformation.addressPayProceedsToDefault });
    }
    else {
    }
  }
  else {
  }

  return;
}

// 「出品:クリア」ボタン押下 HANDLE CLICK CLEAR EXHIBIT
async function handleClickClearExhibit(state, dispatch) {
  dispatch({ type: 'setState', key: 'exhibit',
    value: {
      exhibitNo: '',
      addressMain: '',
      // addressMainCoinType: 'mona',
      addressCardFrom: '',
      addressPayProceedsTo: '',
      tokenName: '',
      amountToSell: '',
      priceMona: { face: '', value: '' },
      signatureByAddressMain: '',
      signatureByAddressCardFrom: '',
      disabled: false,
      status: 'waitingForSignature',
    }
  });

  return;
}

/*
// BUILD MONAPARTY TRANSACTIONS
async function buildMonapartyTransactions(state, dispatch, keyPairs, actionItemsMultiSources) {
  let requestToMonapartyServer = {};
  let bodyObject = {};
  let result = {};
  let response = {};
  let outValueExcludeChange;
  let change;
  let transactionFee;
  let transactionUnsigned;
  let transactionSigned;
  let txid;
  let serverIndex = 0;

  requestToMonapartyServer.method = 'POST';

  devLog('actionItemsMultiSources', JSON.stringify(actionItemsMultiSources));

  SOURCE: for (const source of Object.keys(actionItemsMultiSources)) {
    const keyPair = keyPairs?.[source]?.keyPair;

    ACTION_ITEM: for (const actionItem of actionItemsMultiSources[source]) {
      // actionItem単位でトランザクションを作成し、ブロードキャストする。

      if (actionItem.status === 'unprocessed') {
        if (actionItem.action === 'send') {
          // パラメータ作成

          const destinations = [];
          const assets = [];
          const quantitys = [];

          for (const destination of Object.keys(actionItem.recipients)) {
            for (const asset of Object.keys(actionItem.recipients[destination])) {
              destinations.push(destination);
              assets.push(asset);
              quantitys.push(actionItem.recipients[destination][asset].quantity);
            }
          }

          if (destinations.length < 1 || assets.length < 1 || quantitys.some( quantity => quantity <= 0)) {
            // continue ACTION_ITEM;
            break SOURCE;
          }

          // トランザクション作成

          bodyObject = {
            "jsonrpc":"2.0",
            "id":0,
            "method":"proxy_to_counterpartyd",
            "params": {
              "method":"create_send",
              "params": {
                "source": source,
                "destination": destinations.length >= 2 ? destinations : destinations[0],
                "asset": assets.length >= 2 ? assets : assets[0],
                "quantity": quantitys.length >= 2 ? quantitys : quantitys[0],
                "extended_tx_info": true,
              }
            }
          };

          requestToMonapartyServer.body = JSON.stringify(bodyObject);

          let buildTransactionRetryCount = 0;

          while (response.status !== 'fulfilled') {
            requestToMonapartyServer.url = `https://${state.config.clientParameters.monapaServer.domainAndPath[serverIndex]}`;
            console.log('request create_send', JSON.stringify(requestToMonapartyServer));

            response = await syncHttpRequest(requestToMonapartyServer);
            console.log('response', JSON.stringify(response));

            if (response.status === 'rejected' || response.body.error !== undefined) {
              devLog('create_send to counterpartyd; rejected');
              buildTransactionRetryCount++;

              if (serverIndex >= state.config.clientParameters.monapaServer.domainAndPath.length - 1) {
                serverIndex = 0;
              }
              else {
                serverIndex++;
              }

              await setTimeout(state.config.clientParameters.retry.buildTransaction.retryWaitingTime);
              // keepSqsMessage = true;
              // continue;
            }
            else {
              transactionUnsigned = response.body.result.tx_hex;
              outValueExcludeChange = response.body.result.btc_out;
              change = response.body.result.btc_change;
              transactionFee = response.body.result.btc_fee;
              devLog('transactionUnsigned', transactionUnsigned);
            }

            if (buildTransactionRetryCount > state.config.clientParameters.retry.buildTransaction.retryMax) {
              // -- retry over エラー終了
              const error = response.status === 'rejected' ? response.error : response.body.error;

              devLog(`build transaction retry over.; ${error}`);
              dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToSendToken[state.language]}; failed to build transaction.; ${error}` });

              actionItem.status = 'failed';
              actionItem.statusDetail = 'failedToBuildTransaction';
              actionItem.error = error;
              // continue ACTION_ITEM;
              break SOURCE;
            }
          }

          // トランザクション署名

          if (keyPair !== undefined) {
            result = {};

            result = signTransaction(transactionUnsigned, keyPair);
            devLog('sign transaction; result', JSON.stringify(result));

            if (result.status === 'fulfilled') {
              devLog('succeeded to sign transaction.');

              transactionSigned = result.body;
              actionItem.transactionSigned = transactionSigned;
              actionItem.outValueExcludeChange = outValueExcludeChange;
              actionItem.transactionFee = transactionFee;
              actionItem.status = 'succeeded';
              actionItem.statusDetail = 'signed';
            }
            else {
              devLog(`failed to sign transaction.; ${result.error}`);
              dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToSendToken[state.language]}; failed to sign transaction.; ${result.error}` });

              actionItem.status = 'failed';
              actionItem.statusDetail = 'failedToSignWithKey';
              actionItem.error = result.error;
              // continue ACTION_ITEM;
              break SOURCE;
            }
          }
          else { // Mpurse
            result = {};

            result = await window.mpurse.signRawTransaction(transactionUnsigned)
            .then( async (result) => {
              devLog('succeeded to sign transaction.');
              devLog(result);

              return {
                status: 'fulfilled',
                body: result,
              };
            })
            .catch( (error) => {
              devLog('failed to sign transaction.');
              devLog(error);

              // notification
              dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSend[state.language] });

              return {
                status: 'rejected',
                body: error
              };
            });

            if (result.status === 'fulfilled') {
              devLog('succeeded to sign transaction.');

              transactionSigned = result.body;
              actionItem.transactionSigned = transactionSigned;
              actionItem.outValueExcludeChange = outValueExcludeChange;
              actionItem.transactionFee = transactionFee;
              actionItem.status = 'succeeded';
              actionItem.statusDetail = 'signed';
            }
            else {
              devLog(`failed to sign transaction with Mpurse.; ${result.error}`);
              dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToSendToken[state.language]}; failed to sign transaction with Mpurse.; ${result.error}` });

              actionItem.status = 'failed';
              actionItem.statusDetail = 'failedToSignWithMpurse';
              actionItem.error = result.error;
              // continue ACTION_ITEM;
              break SOURCE;
            }
          }
        }
        else { // sendしかない
        }

        break SOURCE;
      }
    }
  }

  return actionItemsMultiSources;
}
*/

export {
  handleClickSignExhibit,
  handleClickSendToken,
  handleClickDefaultExhibit,
  handleClickClearExhibit,
};